import React from "react";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";

export const SiteShell = ({ children }) => {
  return (
    <div className="min-h-screen bg-black text-white relative">
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default SiteShell;
